// extracted by mini-css-extract-plugin
module.exports = {"roomItem":"Homepage_roomItem__35l0V","roomList":"Homepage_roomList__2o0H6","details":"Homepage_details__2BuQI"};